module.exports = __webpack_public_path__ + "media/conmex/biblioteca-f266df1f.png";